module.exports = __webpack_public_path__ + "static/media/jackpots-lvl1.d8679f6b.png";